import React from "react";
import { useIntl } from "react-intl";

import { Wrapper, Container, Item } from "./styles";
import { IProps } from "./interfaces";

const ContextMenu = ({ getItems, publicView, planId, top = "auto", bottom = "auto", mobileTop = "auto", mobileBottom = "auto", align = "center", mobileAlign = "center", backgroundColor, width = 160, textAlign = "left" }: IProps) => {
    const { formatMessage } = useIntl();
    const items = getItems(formatMessage, { publicView, planId });
    const styles = { top, bottom, mobileTop, mobileBottom, width };
    return (
        <Wrapper styles={styles} align={align} mobileAlign={mobileAlign}>
            <Container styles={styles} align={align} mobileAlign={mobileAlign} backgroundColor={backgroundColor}>
                {items.map(({ label, link, onClick }) => {
                    if (link) {
                        return (
                            <Item key={link} to={link} onClick={onClick} style={{ textAlign }}>
                                {label}
                            </Item>
                        )
                    } else {
                        return (
                            <Item key={link} as="a" href="#" onClick={onClick} style={{ textAlign }}>
                                {label}
                            </Item>
                        )
                    }
                })}
            </Container>
        </Wrapper>
    )
};

export default ContextMenu;
